import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ProcessRequest, ProductionProcessProduct, ProductProcessRequest, UpdateProductProcessRequest } from 'src/app/models/production-process';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';
import { ProductionProcessService } from 'src/app/services/production-process.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { dr } from '@fullcalendar/core/internal-common';

interface ProductType {
  id: number;
  name: string;
  value: string;
}

interface ProductProcess {
  product: any;
  quantity: number;
  type: string;
  productId: number;
  percentage: number;
  productAssociate: number;
  detailId: number;
}

@Component({
  selector: 'app-edit-production-process',
  templateUrl: './edit-production-process.component.html',
  styleUrls: ['./edit-production-process.component.scss']
})
export class EditProductionProcessComponent implements OnInit {
  @Input() processId: number | null = null;
  @Input() showModal: boolean = false;
  types: ProductType[] = [
    { id: 1, name: 'INPUT', value: 'Entrada' },
    { id: 2, name: 'OUTPUT', value: 'Salida' },
  ];
  name = "";
  productType = "INPUT";
  inputs = {
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  products: ProductResponse[] = [];
  filterProducts: ProductResponse[] = [];
  timeout = null;
  productsProcessIn: ProductProcess[] = [];
  productsProcessOut: ProductProcess[] = [];
  productsProcess: ProductionProcessProduct[] = [];
  loading = false;

  selectedInId: number | null = null;
  relations = new Map<number, number[]>();

  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;
  @HostListener('window:resize') onResize() { this.drawMultipleLinks(); }
  buttonAssociate: ButtonLoading = new ButtonLoading('btn-success', false, 'GUARDAR', 'fa-save');

  constructor(
    private productService: ProductService,
    private productionProcessService: ProductionProcessService,
    private toastService: ToastrService,
    private authService: AuthenticationService
  ) {
  }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getProducts("");
    this.getProcess();
  }

  getProcess() {
    if (this.processId == null)
      return;

    this.loading = true;

    this.productionProcessService.getProductionProcessDetails(this.processId).subscribe({
      next: (response: ResponseObject) => {
        this.productsProcess = response.data;
        this.setProduct();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles del proceso productivoc", "Error");
        this.loading = false;
      }
    });
  }

  setProduct() {
    this.productsProcessIn = [];
    this.productsProcessOut = [];
    this.relations = new Map<number, number[]>();

    if (this.productsProcess.length > 0) {
      this.productsProcess.forEach((ps) => {
        if (ps.type == "INPUT") {
          this.productsProcessIn.push({
            product: ps.productData,
            quantity: ps.quantity,
            type: ps.type,
            productId: ps.productId,
            percentage: null,
            productAssociate: null,
            detailId: ps.id
          });
        } else {
          this.productsProcessOut.push({
            product: ps.productData,
            quantity: ps.quantity,
            type: ps.type,
            productId: ps.productId,
            percentage: ps.percentage,
            productAssociate: ps.productAssociate,
            detailId: ps.id
          });
          this.selectedInId = ps.productAssociate;
          this.toggleOutSimple(ps.productId);
        }
      });
      this.drawMultipleLinks();
    }
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;
    this.addProduct();
  }

  addProduct() {
    if (this.inputs.product.verified && this.inputs.product.data) {
      if (this.productType === "INPUT") {
        const exists = this.productsProcessIn.find(p => p.product.id === this.inputs.product.data.id);
        if (exists) {
          this.toastService.error("El producto ya fue agregado como entrada");
          return;
        }
        this.productsProcessIn.push({
          product: this.inputs.product.data,
          quantity: 1,
          type: this.productType,
          productId: this.inputs.product.data.id,
          percentage: 0,
          productAssociate: null,
          detailId: null
        });
      } else {
        const exists = this.productsProcessOut.find(p => p.product.id === this.inputs.product.data.id);
        if (exists) {
          this.toastService.error("El producto ya fue agregado como salida");
          return;
        }
        this.productsProcessOut.push({
          product: this.inputs.product.data,
          quantity: 1,
          type: this.productType,
          productId: this.inputs.product.data.id,
          percentage: 0,
          productAssociate: null,
          detailId: null
        });
      }
      this.changeInput(this.inputs.product, null, false, null, 'fa-list', null);
    } else {
      this.toastService.error("Debe seleccionar un producto válido");
    }
  }

  deleteProduct(index: number, type: string) {
    if (this.processId == null) {
      this.toastService.error("Proceso productivo no válido", "Error");
      return;
    }

    let detailId = null;

    if (type === "INPUT") {
      detailId = this.productsProcessIn[index].detailId;
      this.productsProcessIn.splice(index, 1);
    } else {
      detailId = this.productsProcessOut[index].detailId;

      this.productsProcessOut.splice(index, 1);
    }

    this.cleanRelations();
    this.drawMultipleLinks();

    if (detailId == null) {
      return;
    }

    this.productionProcessService.deleteProductionProcessDetail(this.processId, detailId).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Producto eliminado del proceso productivo", "Exito");
        this.cleanRelations();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al eliminar el producto del proceso productivo", "Error");
      }
    });
  }

  toggleIn(productId: number) {
    this.selectedInId = this.selectedInId === productId ? null : productId;
    this.drawMultipleLinks();
  }

  toggleOutSimple(productId: number) {
    const inId = this.selectedInId;
    if (!inId) return;


    const related = this.relations.get(inId) ?? [];

    if (related.includes(productId)) {
      // Quitar el producto si ya estaba
      this.relations.set(inId, related.filter(id => id !== productId));
    } else {
      // Agregar el producto si no estaba
      this.relations.set(inId, [...related, productId]);
    }
  }

  toggleOut(productId: number) {
    const inId = this.selectedInId;
    if (!inId) return;

    for (const [key, values] of this.relations.entries()) {
      if (key !== inId && values.includes(productId)) {
        this.toastService.warning("El producto de salida ya esta asignado a un producto de entrada.", "Advertencia")
        return; // Detener ejecución
      }
    }

    const related = this.relations.get(inId) ?? [];

    if (related.includes(productId)) {
      // Quitar el producto si ya estaba
      this.relations.set(inId, related.filter(id => id !== productId));
    } else {
      // Agregar el producto si no estaba
      this.relations.set(inId, [...related, productId]);
    }

    this.drawMultipleLinks();
  }

  isSelectedOut(productId: number): boolean {
    const inId = this.selectedInId;
    if (!inId) return false;

    const related = this.relations.get(inId) ?? [];

    if (related.includes(productId)) {
      return true;
    }
    return false;
  }

  drawMultipleLinks() {
    const inId = this.selectedInId;
    const svg = this.svgContainer?.nativeElement as SVGElement;

    if (!svg) return;

    svg.innerHTML = '';

    if (!inId) return;
    setTimeout(() => {
      const parentRect = (svg.parentElement as HTMLElement).getBoundingClientRect();
      const selectedRow = document.querySelector(`#table-in-${this.processId} tr.selected`) as HTMLElement;
      if (!selectedRow) return;

      const selectedRect = selectedRow.getBoundingClientRect();
      const x1 = selectedRect.right - parentRect.left - 12;
      const y1 = selectedRect.top + selectedRect.height / 2 - parentRect.top;

      if (!this.relations.get(inId)) return;


      for (let i = 0; i < this.relations.get(inId).length; i++) {
        const element = this.relations.get(inId)[i];

        const pid = element;

        const relatedRow = document.querySelector(`#table-out-${this.processId} tr[data-id="${pid}"]`) as HTMLElement;
        if (!relatedRow) return;

        const rect = relatedRow.getBoundingClientRect();
        const x2 = rect.left - parentRect.left - 12;
        const y2 = rect.top + rect.height / 2 - parentRect.top;
        const xMiddle = x1 + ((x2 - x1) / 2);

        this.drawLine(svg, x1, xMiddle, y1, y1);
        this.drawLine(svg, xMiddle, x2, y2, y2);
        this.drawLine(svg, xMiddle, xMiddle, y1, y2);
      }

    }, 50);
  }

  private drawLine(svg: SVGElement, x1: number, x2: number, y1: number, y2: number) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', String(x1));
    line.setAttribute('y1', String(y1));
    line.setAttribute('x2', String(x2));
    line.setAttribute('y2', String(y2));
    line.setAttribute('stroke', '#001f54');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }

  getDisabledSave(): boolean {
    return this.productsProcessIn.length == 0 || this.productsProcessOut.length == 0;
  }

  allOutputsAreRelated(): boolean {
    const outputIds = this.productsProcessOut.map(p => p.product.id);
    const allRelatedIds = Array.from(this.relations.values()).reduce(
      (acc, arr) => acc.concat(arr),
      [] as number[]
    );

    const relatedSet = new Set(allRelatedIds);
    return outputIds.every(id => relatedSet.has(id));
  }

  cleanRelations() {
    // 1️⃣ Crear conjuntos para búsqueda rápida
    const inputIds = new Set(this.productsProcessIn.map(p => p.product.id));
    const outputIds = new Set(this.productsProcessOut.map(p => p.product.id));

    // 2️⃣ Recorrer todas las claves actuales del mapa
    for (const [key, values] of Array.from(this.relations.entries())) {
      // 3️⃣ Si la clave no existe en los productos de entrada, eliminarla completamente
      if (!inputIds.has(key)) {
        this.relations.delete(key);
        continue; // Pasar a la siguiente clave
      }

      // 4️⃣ Filtrar los valores que aún existen en productsProcessOut
      const filteredValues = values.filter(v => outputIds.has(v));

      if (filteredValues.length > 0) {
        // 5️⃣ Si quedan valores válidos, actualizamos la entrada
        this.relations.set(key, filteredValues);
      } else {
        // 6️⃣ Si no quedan valores válidos, eliminamos completamente la clave
        this.relations.delete(key);
      }
    }
  }

  findKeyByValue(valueId: number): number | null {
    for (const [key, values] of this.relations.entries()) {
      if (values.includes(valueId)) {
        return key; // Devuelve la primera clave donde aparece
      }
    }
    return null; // No se encontró
  }

  saveAssociation() {
    this.cleanRelations();

    if (!this.allOutputsAreRelated()) {
      this.toastService.error("Todos los productos de salida deben esta relacionados con un productos de entrada", "Error");
      return;
    }

    if (this.productsProcessIn.length === 0) {
      this.toastService.error("Debe agregar al menos un producto de entrada");
      return;
    }
    if (this.productsProcessOut.length === 0) {
      this.toastService.error("Debe agregar al menos un producto de salida");
      return;
    }

    this.buttonAssociate.loading = true;
    const productsInReq: UpdateProductProcessRequest[] = this.productsProcessIn.map((ps) => {
      return {
        productionProcessProductId: ps.detailId,
        productId: ps.product.id,
        quantity: ps.quantity,
        type: ps.type,
        percentage: null,
        productAssociate: null
      }
    });

    const productsOutReq: UpdateProductProcessRequest[] = this.productsProcessOut.map((ps) => {
      return {
        productionProcessProductId: ps.detailId,
        productId: ps.product.id,
        quantity: ps.quantity,
        type: ps.type,
        percentage: ps.percentage,
        productAssociate: this.findKeyByValue(ps.product.id)
      }
    });

    const request = { updateVariousProductionProcessDetail: [...productsInReq, ...productsOutReq] };

    this.productionProcessService.updateProductionProcessVariousDetails(this.processId, request).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Proceso productivo actualizado correctamente", "Exito")
        this.getProcess();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al actualizar el proceso productivo", "Error")
      }
    });


  }

}
